/**
 * リセットCSS処理系Class。
 */
export default class ResetCssLoader {
	/**
	 * リセットCSSエンドポイント。
	 */
	private static resetCssUrl = process.env.VUE_APP_REVICO_FRONT_ENDPOINT + "/css/default.css";

	/**
	 * リセットCSSを読み込む。
	 * 既に他の表示タグで読み込まれてる場合は読み込まない。
	 * ReviCo-MSリポジトリのリセットCSSを参照する。
	 */
	public static resetCssLoad(): void {
		/*
			NOTE:
      `src/assets/style/`配下へリセットCSSを配置&参照右すると、
      Vueの仕様によりリセットCSSが`style`タグで読み込まれてしまう。
      このため、リセットCSSは外部CSSファイルとして読み込む。
		 */

		const head = document.getElementsByTagName("head")[0];
		const linkCss = head.querySelectorAll('link[type="text/css"][rel="stylesheet"][href="' + this.resetCssUrl + '"]');

		// 既にリセットCSSが読み込まれてるなら何もしない
		if (linkCss.length > 0) {
			return;
		}

		// 本体側のリセットCSSをマウントさせる
		const link = document.createElement("link");
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = this.resetCssUrl;
		head.appendChild(link);
	}
}
